import { Icon } from "./Icon";

export function DataStateView({ state, error, onRetry }: { state: "loading" | "error"; error?: string | null; onRetry: () => void }) {
  return (
    <main className="data-state" id="main-content">
      <img src="/icons/newslens-mark-192.png" alt="" width="58" height="58" />
      <p className="data-state__eyebrow">NEWSLENS · LIVE COVERAGE</p>
      <h1>{state === "loading" ? "Collecting current reporting" : "Live briefing unavailable"}</h1>
      <p>{state === "loading"
        ? "NewsLens is retrieving official publisher feeds, grouping reports about the same event, and running the deterministic analysis. The first collection can take a moment."
        : error ?? "The collection service did not return a briefing."}</p>
      <div className="data-state__steps" aria-label="Collection stages">
        <span><Icon name="check" size={20} /> Retrieve RSS headlines</span>
        <span><Icon name="check" size={20} /> Analyze available publisher text</span>
        <span><Icon name="check" size={20} /> Match same-event coverage</span>
      </div>
      {state === "error" ? <button type="button" onClick={onRetry}>Try live collection again</button> : <span className="data-state__pulse" aria-label="Collection in progress" />}
      <small>Demo content is never substituted for a failed live briefing.</small>
    </main>
  );
}
